export default {
  fixdecimal: function (value) {
    if (value && value.length) {
      if (/\d+\.[0]{1}$/.test(value)) return value.split(".")[0]
    }
    return value
  },
  originalPrice: (newValue) => {
    const price = newValue.original_amount
    if (!price) return "~ €"
    const fixedPrice = (price / 100.0).toFixed(2)
    const latinPrice = `${fixedPrice}`.replace(".", ",")
    return latinPrice
  },
  price: (newValue) => {
    const price = newValue.price
    if (!price) return "~ €"
    const fixedPrice = (price / 100.0).toFixed(2)
    const latinPrice = `${fixedPrice}`.replace(".", ",")
    return latinPrice
  },
}
